import { BrandColorCategory, BrandColorItem } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";

/** The fields a color row takes. A legacy slot takes only `hex_code`; null clears a text field. */
export interface BrandColorFields {
    hex_code?: string;
    name?: string | null;
    category?: BrandColorCategory;
    usage_guidelines?: string | null;
    application_guidelines?: string | null;
}

export const brandColorsUrl = (organizationId: string, brandId: string) =>
    `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/colors/`;

/** One list: the legacy color slots, then the brand's color rows. */
export class CommandGetBrandColors {
    async run(organizationId: string, brandId: string): Promise<BrandColorItem[]> {
        return await httpRequest<BrandColorItem[]>(brandColorsUrl(organizationId, brandId), { method: "GET" });
    }
}
